import { MDB_TYPES, SELECTION_TYPES } from "@meddbriefer/scenario-data/constants"

export const genCheckListItemRec = (id, type, label, phase, subPhase, parentID) => {
    return {
        id,
        type,
        label,
        abbrLabel: "",
        feedback: "",
        phase,
        subPhase,
        parentID
    }
}

export const genInterventionRec = (id, label) => {
    return {
        id,
        type: MDB_TYPES.INTERV,
        label,
        abbrLabel: label,
        distPrompts: [],
        prompts: []
    }
}

export const genInterventionPromptRec = (id, label, intvID, type=MDB_TYPES.PROMPT, selectionType=SELECTION_TYPES.ONE) => {
    return {
        id,
        type,
        interventionID: intvID,
        label,
        abbrLabel: "",
        feedback: "",
        selectionType,
        answers: []
    }
}

export const genDistinguishingPromptRec = (id, label) => {
    return {
        id,
        type: MDB_TYPES.DIST_PROMPT,
        label,
        abbrLabel: "",
        selectionType: SELECTION_TYPES.ONE,
        answers: []
    }
}
export const genInterventionPromptAnswerRec = (id, label, promptID) => {
    return {
        id,
        type: MDB_TYPES.ANSWER,
        promptID,
        label,
        abbrLabel: "",
    }
}
export const genInterventionMenuCategoryRec = (id, label) => {
    return {
        id,
        label,
        items: []
    }
}

export const genInterventionMenuItemRec = (id, label, type, intvCategoryID, interventionID=null) => {
    const rec = {
        id,
        label,
        type,
        intvCategoryID,
        depth: 1
    }
    if (!!interventionID) {
        rec.interventionID = interventionID
    }
    return rec
}

export const genProblemRec = (id, label) => {
    return {
        id,
        label,
        lifeThreat: false,
        assessments: [],
        vitals: [],
        notes: [],
        solutions: []
    }
}

export const genSolutionRec = (id, label, problemID) => {
    return {
        id,
        label,
        problemID,
        actions: [],
        protocols: "",
        minimalWhy: ""
    }
}

export const genActionRec = (interventionID, solutionID, problemID) => {
    return {
        id: `${solutionID}-action-${interventionID}`,
        interventionID,
        interventionVariant: {},
        solutionID,
        problemID,
        phase: "",
        why: "",
        protocolRelationship: "",
        contributesToSolution: false,
    }
}